import angular from 'angular';
import 'ng-file-upload';

const recipesServices = angular.module('applicationModule.recipesServices', ['ngFileUpload']);

const checkFiles = function (file) {
    'use strict';

    const files = [];
    const names = [];
    if (angular.isDefined(file)) {
        files.push(file);
        names.push('file');
    }

    return {files: files, names: names};
};

recipesServices.factory('Recipe', ['RecipeAPI', function (RecipeAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return RecipeAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (recipeId) {
            return RecipeAPI.remove(recipeId);
        },
        get: function (recipeId, appId) {
            return RecipeAPI.get(recipeId, appId);
        },
        save: function (data, file, editMode) {
            return RecipeAPI.save(data, file, editMode);
        },
        search: function (appId, search) {
            return RecipeAPI.search(appId, search);
        },
        searchPromotion: function (appId, search) {
            return RecipeAPI.searchPromotion(appId, search);
        },
        searchCategories: function (appId, search) {
            return RecipeAPI.searchCategories(appId, search);
        },
        getAttributes: function (appId) {
            return RecipeAPI.getAttributes(appId);
        },
        bulkDelete: function (ids) {
            return RecipeAPI.bulkDelete(ids);
        },
        changeStatuses: function (ids, status) {
            return RecipeAPI.changeStatuses(ids, status);
        },
        getWithStatusEdit: function (recipeId, appId) {
            return RecipeAPI.getWithStatusEdit(recipeId, appId);
        },
        importData: function (appId, file) {
            return RecipeAPI.importData(appId, file);
        }
    };
}]);

recipesServices.service('RecipeAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/recipes/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.remove = function (recipeId) {
        return $http.delete(API_URL + recipeId);
    };

    this.get = function (recipeId, appId) {
        return $http.get(API_URL + recipeId, {params: {app_id: appId}});
    };

    this.save = function (data, file, editMode) {
        var files = checkFiles(file);

        if (editMode) {
            if (angular.isDefined(file)) {
                var newFields = angular.extend(data, {_method: 'PUT'});

                return Upload.upload({
                    url: API_URL + data.id,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: newFields,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.put(API_URL + data.id, data);
            }
        } else {
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: API_URL,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: data,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.post(API_URL, data);
            }
        }

    };

    this.search = function (appId, search) {
        return $http.get(API_URL + appId + '/tags', {params: {search: search}});
    };

    this.searchPromotion = function (appId, search) {
        return $http.get(API_URL + appId + '/promotions', {params: {search: search}});
    };

    this.searchCategories = function (appId, search) {
        return $http.get(API_URL + appId + '/categories', {params: {search: search}});
    };

    this.getAttributes = function (appId) {
        return $http.get(API_URL + appId + '/attributes');
    };

    this.bulkDelete = function (ids) {
        return $http.post(API_URL + 'delete-selected', {ids: ids});
    };

    this.changeStatuses = function (ids, status) {
        return $http.post(API_URL + 'change-statuses', {ids: ids, status: status});
    };

    this.getWithStatusEdit = function (recipeId, appId) {
        return $http.get(API_URL + recipeId + '/status-edit', {params: {app_id: appId}});
    };

    this.importData = function (appId, file) {
        return Upload.upload({
            url: API_URL + appId + '/import/data',
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };
}]);

recipesServices.factory('RecipeIngredient', ['RecipeIngredientAPI', function (RecipeIngredientAPI) {
    'use strict';

    return {
        getList: function (appId, recipeId, params) {
            return RecipeIngredientAPI.getList(appId, recipeId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        getListAll: function (appId, params) {
            return RecipeIngredientAPI.getListAll(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (ingredientId) {
            return RecipeIngredientAPI.remove(ingredientId);
        },
        get: function (ingredientId, appId) {
            return RecipeIngredientAPI.get(ingredientId, appId);
        },
        getByExternalId: function (externalId, appId) {
            return RecipeIngredientAPI.getByExternalId(externalId, appId);
        },
        save: function (data, editMode) {
            return RecipeIngredientAPI.save(data, editMode);
        },
        changeOrderIngredient: function (data) {
            return RecipeIngredientAPI.changeOrderIngredient(data);
        },
        getAttributes: function (appId) {
            return RecipeIngredientAPI.getAttributes(appId);
        },
        getIngredients: function (appId, recipeId) {
            return RecipeIngredientAPI.getIngredients(appId, recipeId)
                .then(function (response) {
                    return response.data;
                });
        },
        bulkDelete: function (ids) {
            return RecipeIngredientAPI.bulkDelete(ids);
        },
        changeStatuses: function (ids, status) {
            return RecipeIngredientAPI.changeStatuses(ids, status);
        },
        editByExternal: function (data) {
            return RecipeIngredientAPI.editByExternal(data);
        }
    };
}]);

recipesServices.service('RecipeIngredientAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/recipe-ingredients/';

    this.getList = function (appId, recipeId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                recipe_id: recipeId
            })
        });
    };

    this.getListAll = function (appId, params) {
        return $http.get(API_URL + appId + '/all', {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.remove = function (ingredientId) {
        return $http.delete(API_URL + ingredientId);
    };

    this.get = function (ingredientId, appId) {
        return $http.get(API_URL + ingredientId, {params: {app_id: appId}});
    };

    this.getByExternalId = function (externalId, appId) {
        return $http.get(API_URL + externalId, {params: {app_id: appId}});
    };

    this.save = function (data, editMode) {
        if (editMode) {
            return $http.put(API_URL + data.id, data);
        } else {
            return $http.post(API_URL, data);
        }
    };

    this.changeOrderIngredient = function (data) {
        var url = API_URL + 'change-order/';

        return $http.post(url, data);
    };

    this.getAttributes = function (appId) {
        return $http.get(API_URL + appId + '/attributes');
    };

    this.getIngredients = function (appId, recipeId) {
        return $http.get(API_URL, {params: {app_id: appId, recipe_id: recipeId}});
    };

    this.bulkDelete = function (ids) {
        return $http.post(API_URL + 'delete-selected', {ids: ids});
    };

    this.changeStatuses = function (ids, status) {
        return $http.post(API_URL + 'change-statuses', {ids: ids, status: status});
    };

    this.editByExternal = function (data) {
        return $http.put(API_URL + 'bulk-update/' + data.id, data);
    };
}]);

recipesServices.factory('RecipePreparation', ['RecipePreparationAPI', function (RecipePreparationAPI) {
    'use strict';

    return {
        getList: function (appId, recipeId, params) {
            return RecipePreparationAPI.getList(appId, recipeId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (ingredientId) {
            return RecipePreparationAPI.remove(ingredientId);
        },
        get: function (ingredientId, appId) {
            return RecipePreparationAPI.get(ingredientId, appId);
        },
        save: function (data, file, editMode) {
            return RecipePreparationAPI.save(data, file, editMode);
        },
        changeOrder: function (data) {
            return RecipePreparationAPI.changeOrder(data);
        },
        bulkDelete: function (ids) {
            return RecipePreparationAPI.bulkDelete(ids);
        }
    };
}]);

recipesServices.service('RecipePreparationAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/recipe-preparations/';

    this.getList = function (appId, recipeId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                recipe_id: recipeId
            })
        });
    };

    this.remove = function (preparationId) {
        return $http.delete(API_URL + preparationId);
    };

    this.get = function (preparationId, appId) {
        return $http.get(API_URL + preparationId, {params: {app_id: appId}});
    };

    this.save = function (data, file, editMode) {
        var files = checkFiles(file);

        if (editMode) {
            if (angular.isDefined(file)) {
                var newFields = angular.extend(data, {_method: 'PUT'});

                return Upload.upload({
                    url: API_URL + data.id,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: newFields,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.put(API_URL + data.id, data);
            }
        } else {
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: API_URL,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: data,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.post(API_URL, data);
            }
        }

    };

    this.changeOrder = function (data) {
        var url = API_URL + 'change-order/';

        return $http.post(url, data);
    };

    this.bulkDelete = function (ids) {
        return $http.post(API_URL + 'delete-selected', {ids: ids});
    };
}]);

recipesServices.factory('RecipeAuthor', ['RecipeAuthorAPI', function (RecipeAuthorAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return RecipeAuthorAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (authorId) {
            return RecipeAuthorAPI.remove(authorId);
        },
        get: function (authorId, appId) {
            return RecipeAuthorAPI.get(authorId, appId);
        },
        save: function (data, file, editMode) {
            return RecipeAuthorAPI.save(data, file, editMode);
        },
        getAttributes: function (appId) {
            return RecipeAuthorAPI.getAttributes(appId);
        },
        bulkDelete: function (ids) {
            return RecipeAuthorAPI.bulkDelete(ids);
        }
    };
}]);

recipesServices.service('RecipeAuthorAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/recipe-authors/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.remove = function (authorId) {
        return $http.delete(API_URL + authorId);
    };

    this.get = function (authorId, appId) {
        return $http.get(API_URL + authorId, {params: {application_id: appId}});
    };

    this.save = function (data, file, editMode) {
        var files = checkFiles(file);

        if (editMode) {
            if (angular.isDefined(file)) {
                var newFields = angular.extend(data, {_method: 'PUT'});

                return Upload.upload({
                    url: API_URL + data.id,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: newFields,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.put(API_URL + data.id, data);
            }
        } else {
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: API_URL,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: data,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.post(API_URL, data);
            }
        }

    };

    this.getAttributes = function (appId) {
        return $http.get(API_URL + appId + '/attributes');
    };

    this.bulkDelete = function (ids) {
        return $http.post(API_URL + 'delete-selected', {ids: ids});
    };
}]);

recipesServices.factory('RecipesTag', ['RecipesTagAPI', function (RecipesTagAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return RecipesTagAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        remove: function (tagId) {
            return RecipesTagAPI.remove(tagId);
        },
        get: function (tagId, appId) {
            return RecipesTagAPI.get(tagId, appId);
        },
        save: function (data, file, editMode) {
            return RecipesTagAPI.save(data, file, editMode);
        }
    };
}]);

recipesServices.service('RecipesTagAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/recipes-tags/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.remove = function (tagId) {
        return $http.delete(API_URL + tagId);
    };

    this.get = function (tagId, appId) {
        return $http.get(API_URL + tagId, {params: {app_id: appId}});
    };

    this.save = function (data, file, editMode) {
        var files = checkFiles(file);

        if (editMode) {
            if (angular.isDefined(file)) {
                var newFields = angular.extend(data, {_method: 'PUT'});

                return Upload.upload({
                    url: API_URL + 'update/' + data.id,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: newFields,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.put(API_URL + 'update/' + data.id, data);
            }
        } else {
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: API_URL,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: data,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.post(API_URL, data);
            }
        }

    };
}]);

export default recipesServices;